module.exports = __webpack_public_path__ + "img/la.5ffaa04d.svg";